import React, {useEffect, useRef, useState} from "react";
import Input from "../../../UI/Input";
import Checkbox from "../../../UI/Checkbox";
import Switch from "../../../UI/Switch";
import moment from "moment";
import Calendar from "react-calendar";
import { useDispatch, useSelector } from "react-redux";
import {setEquipmentArrivalDate, setSendData,} from "../../../Store/Slice/scheduleSlice";
import useSetPrimaryContact from "../../../Global/Api/Schedule/setPrimaryContact";
import useEmailValidation from "../../../Global/Hooks/emailValidation";
import { useLazyGetFieldsDataQuery } from "../../../Store/Builder/schedule.api";
import FieldDropDown from "./FieldDropDown";
import {useLocation, useParams} from "react-router-dom";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

export default function Form({ checkboxValue, setCheckboxValue }) {
    const {title: jobId} = useParams();
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [type, seType] = useState()
  const dispatch = useDispatch();
  const emailValidation = useEmailValidation();
  const location = useLocation();
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const scheduleTech = useSelector((state) => state.rootReducer.scheduleSlice.tech);
  const { primary_contact, equipment_arrival_date, has_equipment  } = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const [switchValue, setSwitchValue] = useState(jobId !== undefined ? Boolean(has_equipment) : false);
  const [phoneValue, setPhoneValue] = useState(primary_contact?.phone || '')
  const [currentFieldType, setCurrentFieldType] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const setPrimaryContact = useSetPrimaryContact();
  const [dropdownData, setDropdownData] = useState([]);
  const [getFields, { data }] = useLazyGetFieldsDataQuery();
    const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);

    useEffect(() => {
        setSwitchValue(Boolean(has_equipment) || false);
    }, [has_equipment]);

    useEffect(() => {
        if(jobId){
            if (Boolean(has_equipment)) {
                setSwitchValue(true);
                dispatch(setSendData({ has_equipment: true, equipment_arrival_date: null }));
                dispatch(setEquipmentArrivalDate(null));
            } else {
                setSwitchValue(false);
                dispatch(setSendData({ has_equipment: false }));
            }
        }
    }, [jobId, scheduleStep]);

  useEffect(() => {
    return window.addEventListener("click", (e) => {
      if (
        e.target.closest(".verify__dropdown") === null &&
        e.target.closest(".verify__dropdown-elem") === null
      ) {
        setCurrentFieldType(null);
        setDropdownData([]);
      }
    });
  }, [location]);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setCurrentFieldType(null);
        setDropdownData([]);
      }
    });
  }, []);

  useEffect(() => {
        if (!primary_contact) {
            setPhoneValue('');
        }
    }, [primary_contact]);

  const handleSwitch = (event) => {
    setSwitchValue(event.target.checked);
    if (event.target.checked) {
      dispatch(setSendData({ has_equipment: true, equipment_arrival_date: null }));
      dispatch(setEquipmentArrivalDate(null));
    } else {
      dispatch(setSendData({ has_equipment: false }));
    }
  };

  const handleDate = (date) => {
    setShowCalendar(false);
    dispatch(setEquipmentArrivalDate(JSON.stringify(moment(date).format("YYYY-MM-DD"))));
    dispatch(setSendData({ equipment_arrival_date: moment(date).format("YYYY-MM-DD") }));
  };

  const handleCheckbox = (event) => {
    setCheckboxValue(!checkboxValue);
  };

  // const handleEmailChange = (event) => {
  //   emailValidation.handleChange(event);
  //   emailValidation.validateEmail(event.target.value);
  //   handleFieldChange(event);
  // };
    const handleEmailChange = (event) => {
        const value = event.target.value;
        emailValidation.handleChange(event);
        emailValidation.validateEmail(value);
        setPrimaryContact.set({ email: value });
        handleFieldChange(event);
    };

  useEffect(() => {
    if (!emailValidation.value && primary_contact?.email) {
      emailValidation.setChange(primary_contact.email);
      emailValidation.validateEmail(primary_contact.email);
    }
  }, [primary_contact?.email, emailValidation.value]);

  useEffect(() => {
    if (isValidPhoneNumber(phoneValue)) {
      setPrimaryContact.set({
        phone: phoneValue.trim(),
      });
    } else {
      setPrimaryContact.set({ phone: null });
    }
  }, [phoneValue]);

  useEffect(() => {
    setDropdownData(data);
  }, [data]);

  const changeType = (type) => {
    seType(type)
  }

  const handleFieldChange = (e) => {
      setCurrentFieldType(e?.target?.name);
      let targetValue = e?.target?.value;
      if (e?.target?.name === 'phone') {
        targetValue.replaceAll(' ', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '')
      }
      if(targetValue){
          getFields({ field: e?.target?.name, value: targetValue }).then(res => {
              setDropdownData(res?.data)
          });
      }
  };

    return (
    <div className="verify__form">
      <div className="verify__substr">Primary Point of contact</div>
      <p className="verify__p">
        Please add the person that must be contacted on the scheduled date. If
        there is a backup point of contact, please add their info in the
        description in previous step
      </p>

      <div className="verify__row">
        <div
          ref={inputRef}
          onClick={(e) => {
            handleFieldChange(e)
            changeType('firstname')
          }}
          className="verify__field">
          <Input
            label="First name"
            placeholder="First name"
            value={primary_contact?.firstname || ''}
            name={"firstname"}
            autoComplete={"no-firstname"}
            handleChange={(event) => {
              setPrimaryContact.set({ firstname: event.target.value });
              handleFieldChange(event);
            }}
          />
          {type === 'firstname' && data?.length !== 0 && (
            <FieldDropDown
              data={dropdownData}
              key={data?.length}
              setDropdownData={setDropdownData}
              setCurrentFieldType={setCurrentFieldType}
              setPrimaryContact={setPrimaryContact}
              phoneValidation={setPhoneValue}
            />
          )}
        </div>
        <div
          ref={inputRef2}
          onClick={(e) => {
            handleFieldChange(e)
            changeType('lastname')
          }}
          className="verify__field">
          <Input
            label="Last name"
            placeholder="Last name"
            name={"lastname"}
            autoComplete={"no-lastname"}
            value={primary_contact?.lastname || ''}
            handleChange={(event) => {
              setPrimaryContact.set({ lastname: event.target.value });
              handleFieldChange(event);
            }}
          />
          {type === 'lastname' && data?.length !== 0 && (
            <FieldDropDown
              data={dropdownData}
              setDropdownData={setDropdownData}
              setCurrentFieldType={setCurrentFieldType}
              setPrimaryContact={setPrimaryContact}
              phoneValidation={setPhoneValue}
            />
          )}
        </div>
      </div>
      <div className="verify__row">
        <div
          ref={inputRef3}
          onClick={(e) => {
            handleFieldChange(e)
            changeType('phone')
          }}
          className="verify__field">
          <label className="input-phone-number-label">Phone number</label>
          <PhoneInput
            autoComplete={'off'}
            className={`input__fill ${!isValidPhoneNumber(primary_contact?.phone || phoneValue || '') ? 'input-phone-number-error' : 'input-phone-number'}`}
            international
            defaultCountry={accountData?.country_short_name}
            placeholder="Phone number"
            value={primary_contact?.phone || phoneValue || ''}
            name="phone"
            onFocus={() => {
                changeType('phone');
                if (phoneValue) {
                    getFields({ field: 'phone', value: phoneValue }).then(res => {
                        setDropdownData(res?.data || []);
                    });
                }
            }}
            onChange={(value) => {
                const phoneValue = value || '';
                setPhoneValue(phoneValue);
                if (phoneValue && isValidPhoneNumber(phoneValue)) {
                    getFields({ field: 'phone', value: phoneValue }).then(res => {
                        setDropdownData(res?.data || []);
                    });
                }
            }}
          />
          {type === 'phone' && data?.length !== 0 && (
            <FieldDropDown
              data={dropdownData}
              setDropdownData={setDropdownData}
              setCurrentFieldType={setCurrentFieldType}
              setPrimaryContact={setPrimaryContact}
              phoneValidation={setPhoneValue}
            />
          )}
        </div>
        <div
          ref={inputRef4}
          onClick={(e) => {
            handleFieldChange(e)
            changeType('email')
          }}
          className="verify__field">
          <Input
            label="Email"
            placeholder="Email"
            type="email"
            icon="/assets/icons/email-icon.svg"
            value={emailValidation.value}
            name={"email"}
            autoComplete={"no-email"}
            handleChange={handleEmailChange}
          />
          {type === 'email' && data?.length !== 0 && (
            <FieldDropDown
              data={dropdownData}
              setDropdownData={setDropdownData}
              setCurrentFieldType={setCurrentFieldType}
              setPrimaryContact={setPrimaryContact}
              phoneValidation={setPhoneValue}
            />
          )}
        </div>
      </div>

      <div className="verify__hr"></div>

      <div className="verify__block">
        <div className="verify__box">
          <div className="verify__text">
            Have you received all of your equipment ?
          </div>
          <div className="verify__switch">
            <Switch
              id="equipment"
              value={switchValue || false}
              label1="No"
              label2="Yes"
              handleSwitch={handleSwitch}
            />
          </div>
        </div>
        {!switchValue && <div className="verify__hr mt16 mb16"></div>}
        {!switchValue && (
          <div className="verify__box">
            <div className="verify__text">Estimated time of arrival</div>
              <div className="verify__calendar">
                  <div className="s" onClick={() => setShowCalendar(true)}>
                        <span>
                          {equipment_arrival_date
                              ? moment(equipment_arrival_date).format("DD MMM, YYYY")
                              : "Select date"}
                        </span>
                                          <span>
                          <img src="/assets/icons/calendar.svg" alt="calendar"/>
                        </span>
                          </div>
                          {showCalendar ? (
                              <Calendar
                                  value={equipment_arrival_date ? new Date(equipment_arrival_date) : null}
                                  onChange={handleDate}
                                  maxDate={scheduleTech?.date ? new Date(JSON.parse(scheduleTech.date)) : new Date()}
                              />
                          ) : null}
                      </div>
                  </div>
                )}
          </div>
        <div className="verify__block">
            <div className="verify__checkbox">
                <Checkbox
                    label="I agree to the"
                    linkText="Terms and conditions"
                    link="/settings/terms"
                    targetBlank={true}
                    defaultChecked={false}
                    onChange={handleCheckbox}
                    id="agree"
                />
            </div>
        </div>
    </div>
  );
}
